import React from 'react';
import { Link } from 'react-router-dom';

export interface DraftPromptModalProps {
  show: boolean;
  onClose: () => void;
  onOpenDirectResume: () => void;
}

export default function DraftPromptModal({
  show,
  onClose,
  onOpenDirectResume,
}: DraftPromptModalProps) {
  if (!show) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-foreground-950/40 backdrop-blur-xs">
      <div className="bg-white rounded-3xl max-w-sm w-full p-6 text-center shadow-2xl animate-in fade-in zoom-in-95 duration-200">
        <div className="w-12 h-12 bg-amber-100 text-amber-600 rounded-full flex items-center justify-center mx-auto mb-3 text-2xl">
          <i className="ri-file-warning-line"></i>
        </div>
        <h3 className="text-lg font-bold text-foreground-950 mb-2">需要先填写求职资料</h3>
        <p className="text-xs text-foreground-500 mb-6 leading-relaxed">
          申请投递岗位前，需要先在【我的求职】中填写求职期望月薪或上传个人简历文件。
        </p>
        <div className="flex flex-col gap-2">
          <button
            onClick={onOpenDirectResume}
            className="w-full py-2.5 bg-primary-500 text-white rounded-xl text-xs font-medium hover:brightness-95 flex items-center justify-center cursor-pointer"
          >
            在线直投简历 (DIRECT_RESUME)
          </button>
          <div className="flex gap-2">
            <button
              onClick={onClose}
              className="flex-1 py-2 border border-gray-200 rounded-xl text-xs font-medium text-foreground-600 cursor-pointer"
            >
              稍后再说
            </button>
            <Link
              to="/my-job-resume"
              className="flex-1 py-2 border border-primary-200 text-primary-600 rounded-xl text-xs font-medium hover:bg-primary-50 flex items-center justify-center cursor-pointer"
            >
              前往【我的求职】
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
